/* Source: /home/sidsolaiyappan/skooch_ai/scheduler/sandbox_scenarios.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { recordDevScenarioHints, clearOptimizeHints } from "../shared/optimize_hints.js";
import { _inlineSandboxSample, _inlineStressSample } from "../shared/sandbox_helpers.js";
import { buildScenarioFixedBlocks } from "../shared/scenario_helpers.js";
import { runOptimize } from "./scheduler_optimize.js";
import { getStoreSchedulerTasks, getStoreFixedBlocks, getStoreScheduleHydrationEpoch, getStoreCategoryTiers, getStoreUserId, getStoreIsAdmin, getStorePrefFocusPeak, getStorePrefWorkStyle, getStoreSleepImportance, getStoreCoachMarkStep, setStoreSchedulerTasks, setStoreFixedBlocks, setStoreSchedule, setStoreOverflow, setStoreSuggestions, setStoreSchConstraints, setStoreSchLog, setStoreSchOptimized, setStoreSchDirty, setStoreDevSyncScheduleAfterOptimize, setStoreSchDevScenarioActive, setStoreSchOptimizeInputTotal, setStoreScheduleHydrationEpoch, setStoreCoachMarkStep } from "../shared/store.js";
function _recordDevScenarioHydrationHints(schedulerTasks, fBlocks) {
  recordDevScenarioHints(schedulerTasks, fBlocks);
}
function _loadSandboxSidebar() {
  setStoreScheduleHydrationEpoch((getStoreScheduleHydrationEpoch() + 1));
  window.__skoochSchScenarioIdx = ((window.__skoochSchScenarioIdx ? window.__skoochSchScenarioIdx : 0) + 1);
  let _entrySchTasks = getStoreSchedulerTasks();
  let _sample = _inlineSandboxSample();
  setStoreSchedulerTasks(_sample.tasks);
  setStoreFixedBlocks([]);
  setStoreSchedule([]);
  setStoreOverflow([]);
  setStoreSuggestions([]);
  setStoreSchConstraints(_sample.constraints);
  setStoreSchLog("Tell skooch how busy your week is to load a sample week.");
  setStoreSchOptimized(false);
  setStoreSchDirty(true);
  setStoreDevSyncScheduleAfterOptimize(false);
  setStoreSchDevScenarioActive(true);
  setStoreSchOptimizeInputTotal(0);
  clearOptimizeHints();
  _recordDevScenarioHydrationHints(_entrySchTasks, []);
}
function _applyScenarioToState(result, logText) {
  let _entrySchTasks = getStoreSchedulerTasks();
  let _entryFixedBlocks = getStoreFixedBlocks();
  setStoreSchedulerTasks(result.tasks);
  setStoreFixedBlocks(buildScenarioFixedBlocks(result.events));
  setStoreSchConstraints(result.constraints);
  setStoreSchedule([]);
  setStoreOverflow([]);
  setStoreSuggestions([]);
  setStoreSchLog(logText);
  setStoreSchOptimized(false);
  setStoreSchDirty(true);
  setStoreDevSyncScheduleAfterOptimize(false);
  setStoreSchDevScenarioActive(true);
  setStoreSchOptimizeInputTotal(0);
  clearOptimizeHints();
  _recordDevScenarioHydrationHints(_entrySchTasks, _entryFixedBlocks);
  let _curStep = ((window.__skoochCoachStep !== undefined) ? window.__skoochCoachStep : getStoreCoachMarkStep());
  if ((_curStep === 2)) {
    setStoreCoachMarkStep(3);
    window.__skoochCoachStep = 3;
  }
}
async function runRandomize() {
  setStoreScheduleHydrationEpoch((getStoreScheduleHydrationEpoch() + 1));
  window.__skoochSchScenarioIdx = ((window.__skoochSchScenarioIdx ? window.__skoochSchScenarioIdx : 0) + 1);
  let _idx = window.__skoochSchScenarioIdx;
  let _isAnon = (window.__skoochIsAnon !== false);
  let _usePersonalized = ((!getStoreIsAdmin() && !_isAnon) ? true : false);
  let result = null;
  if (!_isAnon) {
    try {
      if (_usePersonalized) {
        let _tier1 = getStoreCategoryTiers().filter(c => {
          return (c["tier"] === 1);
        });
        let _t1names = ((_tier1 && (_tier1.length > 0)) ? _tier1.map(c => {
          return c.name;
        }) : []);
        result = await window.__skoochJacCall("personalized_scenario", {"idx": _idx, "focus_peak": getStorePrefFocusPeak(), "work_style": getStorePrefWorkStyle(), "sleep_importance": getStoreSleepImportance(), "tier1_categories": _t1names});
      } else {
        result = await window.__skoochJacCall("randomize_scenario", {"idx": _idx});
      }
    } catch (__jac_e) {
      if (true) {
        let _scenarioErr = __jac_e;
        result = null;
      } else {
        throw __jac_e;
      }
    }
  }
  if ((!result || !result.tasks)) {
    result = _inlineSandboxSample();
  }
  _applyScenarioToState(result, "New scenario loaded. Hit Optimize to schedule.");
}
async function runStressTest(severity) {
  setStoreScheduleHydrationEpoch((getStoreScheduleHydrationEpoch() + 1));
  window.__skoochSchScenarioIdx = ((window.__skoochSchScenarioIdx ? window.__skoochSchScenarioIdx : 0) + 1);
  let _idx = window.__skoochSchScenarioIdx;
  let _isAnon = (window.__skoochIsAnon !== false);
  let result = null;
  if (!_isAnon) {
    try {
      result = await window.__skoochJacCall("stress_scenario", {"idx": _idx, "severity": severity});
    } catch (__jac_e) {
      if (true) {
        let _stressErr = __jac_e;
        result = null;
      } else {
        throw __jac_e;
      }
    }
  }
  if ((!result || !result.tasks)) {
    result = _inlineStressSample(severity);
  }
  _applyScenarioToState(result, "Loaded a packed sample week. Hit Optimize to plan it.");
}
export {_applyScenarioToState, _loadSandboxSidebar, _recordDevScenarioHydrationHints, runRandomize, runStressTest};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:_recordDevScenarioHydrationHints": {"is_writer": false, "touches": ["*"]}, "func:_loadSandboxSidebar": {"is_writer": true, "touches": ["*"]}, "func:_applyScenarioToState": {"is_writer": true, "touches": ["*"]}, "func:runRandomize": {"is_writer": true, "touches": ["*"]}, "func:runStressTest": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=sandbox_scenarios.js.map
